var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-403"},[_c('div',{staticClass:"page-content"},[_vm._v("\n  403,权限不足\n  ")])])}]

export { render, staticRenderFns }